<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
        >view_headline</i>

        <app-navbar></app-navbar>

        <div class="col-sm-12">
          <h2 class="text-justify text-center" style="margin:20%">Coming Soon</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  data: () => ({
      isSidebar: false,
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
  }
  
@media(max-width:768px){
    #menu-toggle {
      display: block;
  }
}
</style>
